const toTimestamp = (value) => new Date(value).getTime()

export const calculateTimelineRangeFit = ({
  periodStart,
  periodEnd,
  rangeStart,
  rangeEnd,
  viewportWidth,
  horizontalPaddingPx = 0,
  minZoomPercentage = 100,
  maxZoomPercentage = Infinity,
}) => {
  const periodStartTimestamp = toTimestamp(periodStart)
  const periodEndTimestamp = toTimestamp(periodEnd)
  const rangeStartTimestamp = toTimestamp(rangeStart)
  const rangeEndTimestamp = toTimestamp(rangeEnd)

  if (
    !Number.isFinite(periodStartTimestamp) ||
    !Number.isFinite(periodEndTimestamp) ||
    !Number.isFinite(rangeStartTimestamp) ||
    !Number.isFinite(rangeEndTimestamp) ||
    !Number.isFinite(viewportWidth) ||
    viewportWidth <= 0 ||
    periodStartTimestamp >= periodEndTimestamp ||
    rangeStartTimestamp >= rangeEndTimestamp
  ) {
    return null
  }

  const clippedStart = Math.max(rangeStartTimestamp, periodStartTimestamp)
  const clippedEnd = Math.min(rangeEndTimestamp, periodEndTimestamp)

  if (clippedStart >= clippedEnd) return null

  const periodDuration = periodEndTimestamp - periodStartTimestamp
  const rangeDuration = clippedEnd - clippedStart
  const normalizedPaddingPx = Math.min(
    Math.max(Number(horizontalPaddingPx) || 0, 0),
    viewportWidth / 2
  )
  const availableWidth = Math.max(viewportWidth - normalizedPaddingPx * 2, 0)
  const requestedZoom = (periodDuration / rangeDuration) * (availableWidth / viewportWidth) * 100
  const minimumZoom = Number.isFinite(minZoomPercentage) ? minZoomPercentage : 100
  const maximumZoom = Number.isFinite(maxZoomPercentage)
    ? Math.max(maxZoomPercentage, minimumZoom)
    : Infinity

  return {
    zoomPercentage: Math.min(Math.max(requestedZoom, minimumZoom), maximumZoom),
    scrollStartPercentage: ((clippedStart - periodStartTimestamp) / periodDuration) * 100,
    horizontalPaddingPx: normalizedPaddingPx,
  }
}
